import { serviceLocator } from '@/utils/providers/serviceLocator'
import { CategoryRepository } from '../repositories/CategoryRepository'
import { useQuery } from '@/utils/asyncStateManagement/useQuery'

export async function getCategoryByIdCase(id: number) {
  const newRepository = serviceLocator.getService<CategoryRepository>('CategoryService')
  const { data } = await useQuery({
    fetcher: async () => await newRepository?.getCategoryById(id),
    key: 'category',
    filterData: JSON.stringify(id)
  })
  if (data.value?.error) return
  return data.value
}
